import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "qhh.token";
export const FAMILY_CODE_KEY = "qhh.familyCode";
export const PENDING_INVITE_KEY = "qhh.pendingInvite";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message === "Network Error" ? "Can't reach the server. Try again." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.message === "string") return d.message;
  return fallback;
}

export const fieldErrs = (e) => e?.response?.data?.detail?.errors || null;
export const statusOf = (e) => e?.response?.status;
